// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ctXT","colMin":"styles_colMin__2AytI"};